import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Index/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首屏',
    component: Home,
    meta: {
      title: '首屏'
    }
  },
  {
    path: '/FloorHome',
    name: '首页-地板',
    component: () => import('../views/Home/FloorHome.vue'),
    meta: {
      title: '首页-地板'
    }
  },
  {
    path: '/FloorBannerPage',
    name: '地板',
    component: () => import('../views/BannerPage/FloorBannerPage.vue'),
    meta: {
      title: '地板'
    }
  },
  {
    path: '/TianYuanHome',
    name: '首页-管道',
    component: () => import('../views/Home/TianYuanHome.vue'),
    meta: {
      title: '首页-管道'
    }
  },
  {
    path: '/TianYuanBannerPage',
    name: '管道',
    component: () => import('../views/BannerPage/TianYuanBannerPage.vue'),
    meta: {
      title: '管道'
    }
  },
  {
    path: '/about',
    name: '关于天亿',
    component: () => import('../views/About/About.vue'),
    meta: {
      title: '关于天亿'
    }
  },
  {
    path: '/listOfCases',
    name: '案列',
    component: () => import('../views/ListOfCases/ListOfCases.vue'),
    meta: {
      title: '案列'
    }
  },
  {
    path: '/ofCasesDetail',
    name: '案列-详情',
    component: () => import('../views/OfCasesDetail/OfCasesDetail.vue'),
    meta: {
      title: '案列-详情'
    }
  },
  {
    path: '/news',
    name: '新闻',
    component: () => import('../views/News/News.vue'),
    meta: {
      title: '新闻'
    }
  },
  {
    path: '/server',
    name: '服务于支持',
    component: () => import('../views/Server/Server.vue'),
    meta: {
      title: '服务于支持'
    }
  },
  {
    path: '/serverDetail',
    name: '服务于支持',
    component: () => import('../views/ServerDetail/ServerDetail.vue'),
    meta: {
      title: '服务于支持'
    }
  },
  
  {
    path: '/networkMarket',
    name: '网络营销',
    component: () => import('../views/NetworkMarket/NetworkMarket.vue'),
    meta: {
      title: '网络营销'
    }
  },

]




const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

export default router
